module.exports = __webpack_public_path__ + "static/cel-1b66bc4903d7a66aee365b06b8bb323a.png";